<template>
  <div class="project-result-info">
    <el-form :model="form" ref="form" :rules="rules" class="total-price" label-width="150px">
      <el-form-item prop="winBidResult" label="中标结果">
        <el-select
          v-model="form.winBidResult"
          placeholder=""
          :disabled="disabled"
          @change="bidStatusChange"
        >
          <el-option
            v-for="item in bidResultMap"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 已中标选项  start -->
      <el-form-item
        v-if="form.winBidResult == 'BS01' || !form.winBidResult"
        prop="winBidAmount"
        label="中标金额"
      >
        <el-input v-model="form.winBidAmount" type="number" :disabled="disabled"></el-input>
      </el-form-item>
      <el-form-item
        v-if="form.winBidResult == 'BS01' || !form.winBidResult"
        prop="winBidContractNo"
        label="中标合同号"
      >
        <el-input v-model="form.winBidContractNo" :disabled="disabled"></el-input>
      </el-form-item>
      <el-form-item v-if="form.winBidResult == 'BS01' || !form.winBidResult" label="投标管理费">
        <el-input v-model="form.biddingManagementFee" type="number" :disabled="disabled"></el-input>
      </el-form-item>
      <el-form-item
        v-if="form.winBidResult == 'BS01' || !form.winBidResult"
        label="投标保证金处理方式"
      >
        <el-select
          v-model="form.biddingPackageMoneyMethod"
          :disabled="disabled"
          clearable
          placeholder="请选择"
        >
          <el-option label="转为履约保证金" value="转为履约保证金"></el-option>
          <el-option label="不做处理" value="不做处理"></el-option>
        </el-select>
      </el-form-item>
      <!-- 已中标选项  end -->
      <el-form-item v-if="form.winBidResult === 'BS02'" prop="reason" label="未中标原因">
        <el-select v-model="form.reason" :disabled="disabled" placeholder="请选择未中标原因">
          <el-option
            v-for="item in unBidReasonMap"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.winBidResult === 'BS03'" prop="unpaidReason" label="弃标原因">
        <el-select
          v-model="form.unpaidReason"
          placeholder="请选择未弃标原因"
          :disabled="disabled"
          @change="bidStatusChange"
        >
          <el-option
            v-for="item in unpidReasonMap"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="form.winBidResult === 'BS02' || form.winBidResult === 'BS03'"
        prop="specificReason"
        :disabled="disabled"
        label="具体原因"
      >
        <el-input v-model="form.specificReason"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    name: 'ProjectFinish',
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      result: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        form: {
          bidStatus: null,
          amount: '',
          bidContactNo: '',
          manageFee: '',
          dealCash: '',
          unbidReason: '',
          reason: '',
          unpaidReason: '',
        },
        rules: {
          bidStatus: [
            {
              required: true,
              message: '请选择中标结果',
              trigger: 'blur',
            },
          ],
          amount: [
            {
              required: true,
              message: '请输入中标金额',
              trigger: 'blur',
            },
          ],
          bidContactNo: [
            {
              required: true,
              message: '请输入中标合同号',
              trigger: 'blur',
            },
          ],
          unbidReason: [
            {
              required: true,
              message: '请选择未中标原因',
              trigger: 'blur',
            },
          ],
          unpaidReason: [
            {
              required: true,
              message: '请选择未中标原因',
              trigger: 'blur',
            },
          ],
          reason: [
            {
              required: true,
              message: '请输入未中标原因',
              trigger: 'blur',
            },
          ],
        },
        unpidReasonMap: [
          {
            label: '主动放弃',
            value: 0,
          },
          {
            label: '公司撤资',
            value: 1,
          },
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
        dictListMap: (state) => state.dict.dictListMap,
      }),
      bidResultMap() {
        return this.dictListMap ? this.dictListMap['PROJECT_INITIATION_BID_STATUS'] : [];
      },
      unBidReasonMap() {
        return this.dictListMap ? this.dictListMap['PROJECT_INITIATION_UNBID_REASON'] : [];
      },
    },
    watch: {
      result: {
        immediate: true,
        handler(val) {
          if (val && val.toString() != '{}') {
            Object.assign(this.form, val);
          }
        },
      },
    },
    methods: {
      // 关闭项目完结弹窗
      close() {
        this.$emit('change', false);
        this.$refs.form.resetFields();
      },
      bidStatusChange() {
        this.form.amount = '';
        this.form.bidContactNo = '';
        this.form.dealCash = '';
        this.form.manageFee = '';
        this.form.unbidReason = '';
        this.form.reason = '';
        this.form.unpaidReason = '';
      },
      // 项目完结确认
      finishProjectHandle() {},
    },
  };
</script>

<style lang="scss" scoped>
  .project-result-info {
    width: 500px;
  }
</style>
